module.exports = __webpack_public_path__ + "img/eraser.1493548f.jpeg";